export const toolCategories = [
  { slug: 'common', label: '常用' },
  { slug: 'family', label: '家庭' },
  { slug: 'image', label: '图片' },
  { slug: 'pdf', label: 'PDF' },
  { slug: 'text', label: '文本' },
  { slug: 'developer', label: '开发' },
  { slug: 'investment', label: '投资' },
  { slug: 'health', label: '健康' }
] as const

export type ToolCategorySlug = typeof toolCategories[number]['slug']
